import { BrandInfo, IRegion, ProductInfo } from '../redux/AppReducer';

type DistributorRegionKey =
	| 'keheRegion'
	| 'UNFIRegion'
	| 'otherDistributorRegion'
	| 'DotFoodsRegion'
	| 'DPIRegion'
	| 'PodFoodsRegion'
	| 'ThresholdEntRegion';

const DISTRIBUTOR_CONFIG_FOR_UPDATE: Array<{
	regionKey: DistributorRegionKey;
}> = [
	{ regionKey: 'keheRegion' },
	{ regionKey: 'UNFIRegion' },
	{ regionKey: 'otherDistributorRegion' },
	{ regionKey: 'DotFoodsRegion' },
	{ regionKey: 'DPIRegion' },
	{ regionKey: 'PodFoodsRegion' },
	{ regionKey: 'ThresholdEntRegion' }
];
export const buildUpdateObjectBrand = (brand: BrandInfo) => {
	const servicesProviders = brand.otherServicesNeeds?.reduce((result, serviceNeed) => {
		result[serviceNeed.id] = serviceNeed.isActive;
		return result;
	}, {} as Record<string, boolean>);
	const currentRetail = brand.currentRetailChannels?.reduce((result, retail) => {
		result[retail.id] = retail.isActive;
		return result;
	}, {} as Record<string, boolean>);
	const idsToExclude = ['PodFoods', 'ThresholdEnt', 'DotFoods', 'DPI'];

	const currentDistTransform = brand.currentDistributionChannels
		?.filter(dist => !idsToExclude.includes(dist.id))
		.reduce((result, dist) => {
			result[dist.id] = dist.isActive;
			return result;
		}, {} as Record<string, boolean>);

	const otherReg = brand.otherDistributorRegion?.reduce((result, region) => {
		result[region.id] = region.isActive!;
		return result;
	}, {} as Record<string, boolean>);
	const brandBrokers = brand
		.brokers!.filter(broker => broker.name.length > 0)
		.map((broker, index) => ({
			brandBrokerName: broker.name,
			brandBrokerPhone: broker.phone,
			brandBrokerEmail: broker.email,
			brandBrokerId: index.toString()
		}));
	const attributes = brand.brandAttributes
		.filter(attr => attr.isActive)
		.map(attr => attr.id)
		.join(';');
	const processingTech = brand.processingTechniques
		?.filter(technique => technique.isActive)
		.map(tech => {
			return {
				name: tech.name,
				id: tech.id
			};
		});
	const transformedRegions = DISTRIBUTOR_CONFIG_FOR_UPDATE.reduce((acc, config) => {
		const regionArray = brand[config.regionKey];
		if (regionArray) {
			acc[config.regionKey] = regionArray.reduce((result, region) => {
				result[region.id] = region.isActive!;
				return result;
			}, {} as Record<string, boolean>);
		}
		return acc;
	}, {} as Record<DistributorRegionKey, Record<string, boolean>>);

	return {
		brandStory: brand.brandStory ? brand.brandStory : '',
		brandMission: brand.brandMission ? brand.brandMission : '',
		salesforceAccount: brand.salesforceAccount,
		uniqueApplicationSessionId: brand.uniqueApplicationSessionId,
		brandVideo: brand.brandVideo!.length > 0 ? brand.brandVideo : null,
		brandWebsite: brand.brandWebsite!.length > 0 ? brand.brandWebsite : null,
		ownedByParentCompany: brand.ownedByParentCompany,
		ownedByHoldingCompany: brand.ownedByHoldingCompany,
		holdingCompany: brand.ownedByHoldingCompany
			? brand.holdingCompany!.length > 0
				? brand.holdingCompany
				: null
			: null,
		brandHQCity: brand.brandHQCity!.length > 0 ? brand.brandHQCity : null,
		brandHQCountry: brand.brandHQCountry!.length > 0 ? brand.brandHQCountry : null,
		brandHQState: brand.brandHQState!.length > 0 ? brand.brandHQState : null,
		brandYearFound: brand.brandYearFound! > 0 ? brand.brandYearFound : null,
		parentCompany: brand.ownedByParentCompany
			? brand.parentCompany!.length > 0
				? brand.parentCompany
				: null
			: null,
		brandRepEmail: brand.brandRepEmail!.length > 0 ? brand.brandRepEmail : null,
		brandRepName: brand.brandRepName!.length > 0 ? brand.brandRepName : null,
		brandRepPhone: brand.brandRepPhone!.length > 0 ? brand.brandRepPhone : null,
		brandRepTitle: brand.brandRepTitle!.length > 0 ? brand.brandRepTitle : null,
		productRepEmail: brand.productRepEmail!.length > 0 ? brand.productRepEmail : null,
		productRepName: brand.productRepName!.length > 0 ? brand.productRepName : null,
		productRepPhone: brand.productRepPhone!.length > 0 ? brand.productRepPhone : null,
		productRepTitle: brand.productRepTitle!.length > 0 ? brand.productRepTitle : null,
		brandInstagram: brand.brandInstagram!.length > 0 ? brand.brandInstagram : null,
		brandYoutube: brand.brandYoutube!.length > 0 ? brand.brandYoutube : null,
		brandTwitter: brand.brandTwitter!.length > 0 ? brand.brandTwitter : null,
		brandLinkedin: brand.brandLinkedin!.length > 0 ? brand.brandLinkedin : null,
		brandFacebook: brand.brandFacebook!.length > 0 ? brand.brandFacebook : null,
		brandTiktok: brand.brandTiktok!.length > 0 ? brand.brandTiktok : null,
		brandAttributes: attributes.length > 0 ? attributes : null,
		serviceProviderNeeds: servicesProviders,
		processingTechniques: processingTech,
		hasBroker: brand.haveABroker,
		brokers: brandBrokers,
		currentDistributionChannels: currentDistTransform,
		currentRetailChannels: currentRetail,
		keheRegion: transformedRegions.keheRegion,
		UNFIRegion: transformedRegions.UNFIRegion,
		PodFoodsRegion: transformedRegions.PodFoodsRegion,
		ThresholdEntRegion: transformedRegions.ThresholdEntRegion,
		DPIRegion: transformedRegions.DPIRegion,
		DotFoodsRegion: transformedRegions.DotFoodsRegion,
		otherDistributorRegion: otherReg,
		mapPolicy: brand.mapPolicy,
		activelyRaisingCapital: brand.activelyRaisingCapital,
		revenueLastYear: brand.revenueLastYear
			? Number(brand.revenueLastYear.toString().replace(/\D/g, ''))
			: 0,
		revenueExpectedThisYear: brand.revenueExpectedThisYear
			? Number(brand.revenueExpectedThisYear.toString().replace(/\D/g, ''))
			: 0,
		privateLabeServices: brand.privateLabelServices
	};
};
function safeParseFloat(value: any): number | null {
	if (value === null || value === undefined || value === '') {
		return null;
	}
	const number = parseFloat(value);
	return isNaN(number) ? null : number;
}

export const buildUpdateProduct = (product: ProductInfo) => {
	return {
		launchYear: safeParseFloat(product.launchYear),
		flagshipProduct: product.flagshipProduct,
		dimensions: {
			width: safeParseFloat(product.dimensions.width),
			height: safeParseFloat(product.dimensions.height),
			depth: safeParseFloat(product.dimensions.depth),
			weight: safeParseFloat(product.dimensions.weight)
		},
		productMSRP: safeParseFloat(product.productMSRP),
		productShelfLife: safeParseFloat(product.productShelfLife),
		showHowGood: product.showHowGood
	};
};

interface Payload {
	[key: string]: {
		[regionId: string]: boolean;
	};
}

export const mapRegions = (
	regionsArray: IRegion[],
	payload: Payload,
	regionKey: string
): (IRegion & { isActive: boolean })[] => {
	return regionsArray.map(region => ({
		...region,
		isActive: payload[regionKey]?.[region.id] || false
	}));
};
